import { actionTypes } from "./actions";

const initialState = {
  data: [],
  yearOptions: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_MONTH_LOCKS:
      return {
        ...state,
        data: payload,
      };
    case actionTypes.SET_YEAR_OPTIONS:
      return {
        ...state,
        yearOptions: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
